<template>
  <section
    class="
        mobile_add_new_head
        bg--blue
        tx--bege
        center
        flex flex--content--center
        relative
      "
  >
    <div class="title">{{ editSurgery ? "עריכת" : "יצירת" }} תור לניתוח</div>
    <a
      class="m_bt_head head_cancel"
      href="javascript:void(0)"
      @click="$router.go(-1)"
    >
      ביטול
    </a>
    <a
      class="m_bt_head head_save"
      href="javascript:void(0)"
      @click.prevent="$emit('confirmSurg')"
    >
      הבא
    </a>
  </section>
</template>

<script>
export default {
  props: {
    editSurgery: { required: true, default: false }
  }
};
</script>
